import React, {Component} from 'react';

class CompetitorsTypeSelects extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            type: '',
        };
    }
    
    onDataChange = (event) => {
        const value = event.target.value;
        if(value!=="select"){
            this.setState({ type : value })
            this.props.changeCompetitorsGroupsType(value, this.props.data.competitorId)
        }
    };

    render() {

        return(
            <div className='level-select-box'>
                <div className='form-group'>
                    <i class="fas fa-sort"></i>
                    <select onChange={(e) => { this.onDataChange(e)}} value={this.props.data.type} >
                        <option value='select'>Current Gauge</option>
                        <option value='actual'>Actual</option>
                        <option value='potential'>Potential</option>
                    </select>
                </div>
            </div>
        ) 
    }
}

export default (CompetitorsTypeSelects);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CompetitorsGroupsType/CompetitorsTypeSelects/CompetitorsTypeSelects.jsx